import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import CategoriesDropdownMobile from '../CategoriesDropdown/CategoriesDropdownMobile';
import BrandsDropdownMobile from '../BrandsDropdown/BrandsDropdownMobile';
import {useNavigate} from 'react-router-dom';
interface MobileMenuPopProps{
    isOpen : boolean;
    setIsOpen : (isOpen : boolean) => void;
}
const MobileMenuPop = ({isOpen,setIsOpen} : MobileMenuPopProps) => {
  const [searchQuery, setSearchQuery] = useState('');
const navigate = useNavigate();
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Search Query:', searchQuery); // Replace with your search logic
  };
  const handleClick = () => {
    setIsOpen(false);
    navigate('/products');
  }

  return (
    <>   
       {isOpen && <div style={{ fontSize: '1.5rem', paddingTop: '1rem' }} className='mobile-menu-pop'>
        <div onClick={() => handleClick()}>Προϊόντα</div>
           {/* <CategoriesDropdownMobile setIsOpen={setIsOpen}/>
           <BrandsDropdownMobile setIsOpen={setIsOpen} /> */}
        </div>}
    </>
  );
};

export default MobileMenuPop;